import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiFetch } from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

function AdminProtectedRoute({ children }) {
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;
    const checkAdministrator = async () => {
      try {
        const response = await apiFetch(`${API_BASE_URL}/me`);
        const user = response.ok ? await response.json() : null;
        if (!cancelled) setState({ loading: false, allowed: Boolean(user?.is_admin) });
      } catch (error) {
        if (!cancelled) setState({ loading: false, allowed: false });
      }
    };
    checkAdministrator();
    return () => { cancelled = true; };
  }, []);

  if (state.loading) {
    return <div className="authenticated-page"><div className="authenticated-page-content">Checking administrator access…</div></div>;
  }
  if (!state.allowed) return <Navigate to="/dashboard" replace />;
  return children;
}

export default AdminProtectedRoute;
